import { useId } from 'react';
import styles from './parts.module.css';

const Panel = ({ title, sub, right, flush, children }) => {
    const headingId = useId();
    return (
        <section className={styles.panel} aria-labelledby={headingId}>
            <div className={styles.panelHead}>
                <h2 id={headingId} className={styles.panelTitle}>
                    {title}
                </h2>
                {sub && <span className={styles.panelSub}>{sub}</span>}
                {right && <div className={styles.panelRight}>{right}</div>}
            </div>
            <div className={`${styles.panelBody} ${flush ? styles.panelFlush : ''}`}>{children}</div>
        </section>
    );
};

export default Panel;
